import React, { useEffect, useState } from 'react';
import '../css/ContentArea.css';
import ChannelAllocation from './ChannelAllocation';
import Channels from './Channels';
import SSIDs from './SSIDs';
import APs from './APs';
import BSSIDs from './BSSIDs';
import Clients from './Clients';
import Bluetooth from './Bluetooth';
import About from './About';

const ContentArea = ({ selectedOption }) => {
  const [key, setKey] = useState(0); // 用于强制重新加载组件的 key

  useEffect(() => {
    // 每当 selectedOption 变化时，更新 key 以重新加载组件
    setKey(prevKey => prevKey + 1);
  }, [selectedOption]);

  // 根据选项加载对应的组件
  const renderComponent = () => {
    switch (selectedOption) {
      case '信道分配图':
        return <ChannelAllocation key={key} />;
      case '信道':
        return <Channels key={key} />;
      case 'SSIDs':
        return <SSIDs key={key} />;
      case 'APs':
        return <APs key={key} />;
      case 'BSSIDs':
        return <BSSIDs key={key} />;
      case '客户端':
        return <Clients key={key} />;
      case '蓝牙':
        return <Bluetooth key={key} />;
      case '关于':
        return <About key={key} />;
      default:
        return <ChannelAllocation key={key} />;
    }
  };

  return (
    <div className="content-area" style={{ height: '928px' }}>
      {renderComponent()}
    </div>
  );
};

export default ContentArea;
